import React, {useEffect, useState} from "react";
import {withRouter} from "react-router-dom";
import "../../../css/info-client.css";
import {getPublicite} from "../../server/services/client-service";
import {DIV_NAME, LABEL_NAME, SELECT_NAME} from "./info-client-constants";

function InfoClientPublicite(props) {
    const [publicites, setPublicites] = useState([]);

    useEffect(() => {
            getPublicite()
                .then(pubs => {
                    setPublicites(pubs.filter(p => p.afficherEnLigne)); // Ce filter enlève le pubs Aucun
                });
        }
        , [props.match.params.idZec]);

    if (publicites.filter(p => p.idPublicite !== '00000000-0000-0000-0000-000000000000').length === 0) return null;

    return (
        <div className={ DIV_NAME }>
            <label className={ LABEL_NAME }>{ props.label }</label>
            <select className={ SELECT_NAME } name={ props.name } value={ props.value } onChange={ props.onChange }>
                {
                    publicites.length > 0 && publicites.map(pubs => (
                        <option key={ pubs.idPublicite } value={ pubs.idPublicite }>
                            { pubs.idPublicite === '00000000-0000-0000-0000-000000000000' ? '' : props.lang === "fr" || pubs.descriptionAnglais === '' ? pubs.description : pubs.descriptionAnglais }
                        </option>
                    ))
                }
            </select>
        </div>
    );
}

// champs requis
export default withRouter(InfoClientPublicite);

